export default {
  SET_MEMBER_IN_GROUPS(state, value) {
    state.memberInGroups = value;
  },

  SET_USERNAME(state, value) {
    state.username = value;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  }
};
